import type { ReactNode } from 'react'
import type { ContextWork } from '../navigation/context'
import OpenItemsSummary, { type WorkQueue } from '../navigation/OpenItemsSummary'
import './workbench-header.css'

/** Keep the title and counts together; long context names can wrap below. */
export default function WorkbenchHeader({
  scopeLabel,
  work,
  selected,
  onSelect,
  children,
}: {
  scopeLabel: ReactNode
  work: ContextWork | null
  selected: WorkQueue
  onSelect: (queue: WorkQueue) => void
  children?: ReactNode
}) {
  return (
    <div className="workbench-context-header" data-testid="workbench-context-header">
      <header className="fa-card workbench-title">
        <h1>Workbench</h1>
        <div className="workbench-scope-label">{scopeLabel}</div>
        {children}
      </header>
      <section className="fa-card workbench-open-items" aria-labelledby="workbench-open-heading">
        <h2 id="workbench-open-heading">Open items</h2>
        <OpenItemsSummary work={work} selected={selected} onSelect={onSelect} />
      </section>
    </div>
  )
}
